<template>
  <cube-form
    v-bind="$attrs"
    v-on="$listeners"
    ref="form"
    :class="{'formter-elderly': isElderly}"
  >
    <cube-form-group class="formter-main">
      <div class="formter-tip" v-if="tip">
        <slot name="tip">
          {{ tip }}
        </slot>
      </div>
      <div v-for="field in fields" :key="field.modelKey">
        <cube-form-item
          v-if="field.isShow || typeof field.isShow === 'undefined'"
          :field="field"
        >
          <slot :name="field.modelKey" :field="field"></slot>
        </cube-form-item>
      </div>
    </cube-form-group>
  </cube-form>
</template>

<script>
export default {
  props: {
    form: {
    },
    fields: {
      type: Array,
      default: () => []
    },
    tip: {
      type: String,
    },
    isElderly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  mounted() {
    console.log(this.$attrs, 'kkkk')
    this.$emit('update:form', this.$refs.form)
  }
}
</script>

<style lang="scss" scoped>
@import "common-css/mixins.scss";

.cube-form {
  // padding: 0 px2rem(10);
  box-shadow: 0 1px 3px rgba(0, 0, 0, .1);
  border-radius: px2rem(8);
}
.cube-form .cube-form-item {
  display: flex;
  padding: px2rem(10);
}
::v-deep .cube-form-item .cube-form-label {
  width: px2rem(160);
  color: #999;
  padding-bottom: 0;
  font-size: px2rem(28);
}
::v-deep .cube-form-item .cube-form-label::before {
  content: '';
  // display: none;
  margin-left: px2rem(2);
}
::v-deep .cube-validator, .cube-form-field {
  flex: 1;
}
::v-deep .cube-form-item .cube-validator-msg {
  margin: px2rem(-28) 0 0 px2rem(24) !important;
}
::v-deep .cube-input input::placeholder {
  font-size: px2rem(28);
}
.cube-form_classic .cube-form-item:last-child {
  padding-bottom: px2rem(20);
}
.formter-main {
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
.formter-tip {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: px2rem(60);
  border-radius: px2rem(8) px2rem(8) 0 0;
  line-height: 1.5;
  font-size: px2rem(24);
  box-sizing: border-box;
  padding: 0 px2rem(20);
  background: #FAFBFD;
  color: #999;
}

.formter-elderly {
  .formter-tip {
    font-size: px2rem(36);
  }

  ::v-deep .cube-input {
    font-size: px2rem(36);
  }

  ::v-deep .cube-form-label {
    font-size: px2rem(36);
  }
  ::v-deep .cube-input input::placeholder {
    font-size: px2rem(36);
  }
}
</style>
